import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "showBreezeIcon"];
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { getStyledAIButton } from './styledButtons/StyledAIBaseButton';
import { BREEZE_SPECIAL } from '../../../constants/BreezeUse';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AIBaseButton(_ref) {
  let {
      children,
      showBreezeIcon = true
    } = _ref,
    uiButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const useOverride = uiButtonProps.use === BREEZE_SPECIAL ? undefined : uiButtonProps.use;
  const AIButtonComponent = getStyledAIButton(uiButtonProps.use);
  const {
    tokenProps,
    restProps
  } = filterTokenProps(uiButtonProps);
  const cssProps = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(AIButtonComponent
  // keep lowercase to avoid React DOM warnings - this prop will be removed upon future Trellis migration
  , Object.assign({
    $cssstyles: cssProps
  }, restProps, {
    use: useOverride,
    children: [showBreezeIcon && /*#__PURE__*/_jsx(BreezeSingleStarIcon, {
      alignWithText: true
    }), children]
  }));
}